export { useInventoryProducts } from './product.hook'
